import { render } from "./FileActionOptions.vue?vue&type=template&id=6a70a9cd&scoped=true&ts=true"
import script from "./FileActionOptions.vue?vue&type=script&lang=ts"
export * from "./FileActionOptions.vue?vue&type=script&lang=ts"

import "./FileActionOptions.vue?vue&type=style&index=0&id=6a70a9cd&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a70a9cd"]])

export default __exports__